import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteComponent } from './autocomplete.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [AutocompleteComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  exports: [AutocompleteComponent],
  providers: [
    provideNgxMask()
  ]
})
export class AutocompleteModule { }
